import styles from "./EntrySelectItem.module.scss";

export const SelectItem = ({
  children,
  className,
}: React.PropsWithChildren<{ className?: string }>) => (
  <div className={`${styles.selectItem} ${className ?? ""}`}>{children}</div>
);
